import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './ServiceAreasSlider.css';

const DEFAULT_SERVICE_AREAS = ['Yıldırım Mah', 'Kocatepe Mah', 'Kartaltepe Mah', 'Muratpaşa Mah'];

const ServiceAreasSlider = () => {
  const [serviceAreas, setServiceAreas] = useState(DEFAULT_SERVICE_AREAS);

  useEffect(() => {
    const contactRef = ref(database, 'contactInfo');
    const unsubscribe = onValue(contactRef, (snapshot) => {
      const data = snapshot.val();
      if (data && Array.isArray(data.serviceAreas) && data.serviceAreas.length > 0) {
        setServiceAreas(data.serviceAreas);
      } else {
        setServiceAreas(DEFAULT_SERVICE_AREAS);
      }
    });
    return () => unsubscribe();
  }, []);

  const areas = serviceAreas.length > 0 ? serviceAreas : DEFAULT_SERVICE_AREAS;

  return (
    <section id="service-areas" className="service-areas-slider">
      <div className="container">
        <div className="service-areas-header">
          <h2 className="service-areas-title">Hizmet Verdiğimiz Bölgeler</h2>
          <p className="service-areas-subtitle">
            Bayrampaşa ve çevresinde hizmet verdiğimiz mahalleler
          </p>
        </div>
        <div className="service-areas-marquee-wrap">
          <div className="service-areas-marquee">
            {[...areas, ...areas].map((area, index) => (
              <span key={`${area}-${index}`} className="service-area-chip">
                {area}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSlider;
